import addClasses from './addClasses.js';
import removeClasses from './removeClasses.js';
export default {
  addClasses,
  removeClasses
};


// WEBPACK FOOTER //
// ./node_modules/swiper/core/classes/index.js